/*
 * RockHer wishlist hearts for product cards (collection grids and card-product).
 * Uses the same localStorage key and item shape as the wishlist page and the PDP heart
 * (assets/scripts.js), so a piece saved anywhere shows as saved everywhere.
 * Markup: <button type="button" class="rhm-heart" aria-pressed="false" data-id data-handle
 *   data-title data-sku data-price data-image data-collection-name data-inbuilder>
 * One delegated listener, so cards added later (Load More, facet re-renders) need no wiring;
 * a MutationObserver repaints hearts that arrive after load.
 * Never redirects; if storage is blocked nothing happens and nothing throws.
 */
(function () {
  if (window.rhWishlist) return;

  function key() {
    return window.WishlistStorageKey || 'wishlist_v3';
  }

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(key()));
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(key(), JSON.stringify(list));
    } catch (err) {
      return false;
    }
    try {
      window.dispatchEvent(new CustomEvent('wishlistChanged'));
    } catch (err) {}
    return true;
  }

  function sameId(item, id) {
    return !!item && String(item.id) === String(id);
  }

  function has(id) {
    return read().some(function (item) { return sameId(item, id); });
  }

  // Adds the item, or removes it when it is already saved. Returns the saved state afterwards.
  function toggle(item) {
    if (!item || item.id === undefined || item.id === null || item.id === '') return false;
    var list = read();
    var exists = list.some(function (i) { return sameId(i, item.id); });
    if (exists) {
      list = list.filter(function (i) { return !sameId(i, item.id); });
    } else {
      list.push(item);
    }
    write(list);
    return has(item.id);
  }

  function itemFrom(btn) {
    var ds = btn.dataset || {};
    var id = Number(ds.id);
    return {
      id: isNaN(id) ? ds.id : id,
      sku: ds.sku || '',
      collection_name: ds.collectionName || '',
      title: ds.title || '',
      price: Number(ds.price) || 0,
      featured_image: ds.image || '',
      handle: ds.handle || '',
      inbuilder: ds.inbuilder || '0',
      type: 'product'
    };
  }

  function paint(btn, saved) {
    var title = btn.getAttribute('data-title') || 'this piece';
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + title + (saved ? ' from wishlist' : ' to wishlist'));
    // card-product.liquid shows its filled heart through the existing .active class.
    if (btn.classList) btn.classList.toggle('active', saved);
  }

  function paintAll() {
    var saved = {};
    read().forEach(function (item) {
      if (item && item.id !== undefined && item.id !== null) saved[String(item.id)] = true;
    });
    var buttons = document.querySelectorAll('.rhm-heart[data-id]');
    Array.prototype.forEach.call(buttons, function (btn) {
      paint(btn, !!saved[String(btn.getAttribute('data-id'))]);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('.rhm-heart[data-id]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(itemFrom(btn));
    paintAll();
  });

  // Cards inserted later through innerHTML (search and facet re-renders, recommendations,
  // Load More) arrive unpainted; repaint once per frame when hearts are added.
  var queued = false;
  function schedulePaint() {
    if (queued) return;
    queued = true;
    var run = function () { queued = false; paintAll(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { setTimeout(run, 16); }
  }

  function hasHeart(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.rhm-heart[data-id]')) return true;
    return !!(node.querySelector && node.querySelector('.rhm-heart[data-id]'));
  }

  function watch() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasHeart(added[j])) { schedulePaint(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    paintAll();
    watch();
  }

  window.addEventListener('wishlistChanged', paintAll);
  window.addEventListener('pageshow', paintAll);
  window.addEventListener('storage', function (event) {
    if (!event || event.key === null || event.key === key()) paintAll();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.rhWishlist = { has: has, toggle: toggle, paintAll: paintAll };
})();
